import { useEffect, useState } from 'react';
import moment from 'moment-timezone';

export const useFormatBuildInfo = (buildInfo) => {
  const [data, setData] = useState({});

  const convertNumbers = (modelName) => {
    setData((currentValue) => ({
      ...currentValue,
      [modelName]: currentValue[modelName] ? Math.round(currentValue[modelName] / 1000000) : 0,
    }));
  };

  const calculate = () => {
    const {
      updateInfo: { lastUpdated },
      databases: databasesObject,
    } = buildInfo;
    setData((currentValue) => ({ ...currentValue, lastUpdated: moment(lastUpdated).format('DD. MMMM YYYY') }));

    const databases = Object.values(databasesObject);
    if (!databases || !databases.length) {
      return;
    }
    databases.forEach((database) => {
      if (database.prefix === 'RX') {
        database.availableContexts.forEach((context) => {
          const { serverAlias } = context;
          if (
            database.id === '7' &&
            (serverAlias === 'substances' || serverAlias === 'citations' || serverAlias === 'patents' || serverAlias === 'reactions')
          ) {
            return;
          }
          setData((currentValue) => ({ ...currentValue, [serverAlias]: (currentValue[serverAlias] || 0) + context.entriesCount }));
        });
      }

      if (database.prefix === 'RC' || database.prefix === 'PU') {
        // eslint-disable-next-line no-shadow
        const context = database.availableContexts.find((context) => context.serverAlias === 'substances');
        setData((currentValue) => ({ ...currentValue, substances: (currentValue.substances || 0) + context.entriesCount }));
      }
    });
    convertNumbers('substances');
    convertNumbers('patents');
    convertNumbers('citations');
    convertNumbers('dpitems');
    convertNumbers('reactions');
  };
  useEffect(() => {
    if (buildInfo) {
      calculate();
    } else {
      setData({});
    }
    // eslint-disable-next-line
  }, [buildInfo]);
  return data;
};

export default useFormatBuildInfo;
